export const ConsumerNetIncomeErrorMessages = {
  general: {
    id: 'Pages.ConsumerNetIncome.Form.errorGeneral',
    description: 'Cannot submit net income'
  }
}
